<app-page-banner-item
  title="{{ bannerData.title }}"
  text="{{ bannerData.text }}"
  [imgUrl]="bannerData.imgUrl"></app-page-banner-item>
<app-block-text *ngFor="let text of block" [text]="text"></app-block-text>
<div class="mb-30">
  <app-info-cards [cards]="cards"></app-info-cards>
</div>
